﻿$(function () {
	//	var q = $(".toggle-list h3");
	//	q.click(function(event) {
	if (window.__TOGGLE_RUN__ == undefined) { // bandaid: stop from rebinding when loading with pajax
		window.__TOGGLE_RUN__ = 1;
		var page = $("#content");
		page.delegate(".toggle-list h3", "click", function () {
			clickA = $(this).parent().children(".list-body");
			clickA.slideToggle("fast");
			var q = $(this);
			q.toggleClass("list-open");
			return false;
		});

		//q = $(".ui-list.toggle li > a, .ui-list.toggle li > h3 a");
		//q.click(function(event) {
		page.delegate(".ui-list.toggle li > a, .ui-list.toggle li > h3 a", "click", function () {
			$(this).css("outline", "none");
			clickA = $(this).closest('li').children("ul, .list-body");

			var q = $(this);
			if (clickA.is(":visible")) {
				clickA.slideUp("fast", function () {
					q.closest('li').toggleClass("list-open");
				});
			}
			else {
				clickA.slideDown("fast");
				q.closest('li').toggleClass("list-open");
			}
			return false;
		});
	}
});